<template>
    <div>
        <card-header icon="fa-money-check-alt">
            <template #title>
                Plan Transactions
            </template>
        </card-header>

        <card-body>
            <card-list>
                <transaction-tile :transaction="t" :card="card" v-for="t in transactions"/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import {client as http} from '@/http_client';
    import async from "async";
    import DataRow from "../../TIER/components/DataRow";
    import UserTile from "../../components/tiles/UserTile";
    import TransactionTile from "../../components/tiles/TransactionTile";

    export default {
        components: {TransactionTile, UserTile, DataRow, SeparatorListItem, CardFooter, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                transactions: []
            };
        },
        methods: {
            loadPlan: function() {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('payment-plans/' + this.props.planId + '/transactions', {force: true}).then(response => {
                            this.transactions = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.loadPlan();
        }
    };
</script>

<style>
    .fa-check {
        color: green;
    }

    .fa-ban {
        color: red;
    }
</style>
